module.exports = __webpack_public_path__ + "static/media/icon_template_unset.bf5c7272.svg";